module.exports = __webpack_public_path__ + "img/9b19a633a2849e8df8e7d11dd00b0de8.png";